import { render, staticRenderFns } from "./BurgerIcon.vue?vue&type=template&id=68e12927&scoped=true&"
import script from "./BurgerIcon.vue?vue&type=script&lang=js&"
export * from "./BurgerIcon.vue?vue&type=script&lang=js&"
import style0 from "./BurgerIcon.vue?vue&type=style&index=0&id=68e12927&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e12927",
  null
  
)

export default component.exports